/*
 * © 2026 Ecsper Ltd. All rights reserved.
 * SPDX-License-Identifier: LicenseRef-Ecsper-Proprietary
 * Unauthorised use, copying, or distribution is strictly prohibited.
 */

/**
 * Forensic Ledger event types.
 *
 * Source: ECS-DD-MS365-001 v1.0.0 SS B5 ForensicLedgerPublisher
 *
 * The backend ForensicLedgerPublisher accepts these event types.
 * This client-side publisher mirrors the backend contract.
 */
export const LEDGER_EVENTS = {
  REPORT_CREATED: 'report.created',
  REPORT_OPENED: 'report.opened',
  REPORT_SAVED: 'report.saved',
  REPORT_VERSION_CREATED: 'report.version.created',
  /** Client-side events (not in backend yet; for Stage 6 audit expansion) */
  ADDIN_LOADED: 'addin.loaded',
  ADDIN_CLOSED: 'addin.closed',
  DOCUMENT_CONTEXT_READ: 'document.context.read',
  DOCUMENT_CONTEXT_WRITE: 'document.context.write',
} as const;

export type LedgerEventType = (typeof LEDGER_EVENTS)[keyof typeof LEDGER_EVENTS];

/**
 * Default REST path for batched forensic ledger events when HTTP flush is enabled.
 *
 * No workspace HTTP route was found in audit A6; the backend publisher is invoked
 * server-side today. This path is configurable via {@link ForensicLedgerConfig.endpointPath}.
 */
export const LEDGER_ENDPOINT = '/workspace/forensic-ledger/events';
